import * as Constants from '../constants';

/**
 * Emitted during playback when the audio player calculates it has enough content
 *  to play audio w/o further rebuffers. In an ideal case this will happen only
 *  once on initial audio load.
 *  We want to know how often it happens and what display ad is active at the time.
 *  This, along with additional actions logged can help determine whether display ads
 *    are impacting audio playback.
 *
 * @param {Map} displayAd - active display ad
 * @param {string} trackToken - current track
 * @returns {object} action - includes current track and active display ad
 */
export function incrementCanPlayCount(displayAd, trackToken) {
  return {
    type: Constants.Rebuffer.RebufferActions.INCREMENT_CAN_PLAY_COUNT,
    data: {
      displayAd,
      trackToken,
    },
  };
}

/**
 * Resets the canPlayThrough even count. Normally when a track completes
 *  playing.
 *
 * @returns {object} action
 */
export function resetCanPlayCount() {
  return {
    type: Constants.Rebuffer.RebufferActions.RESET_TRACK_CAN_PLAY_COUNT,
  };
}
